import { render, staticRenderFns } from "./CollaborativeEducation.vue?vue&type=template&id=95ee8fb4&scoped=true"
import script from "./CollaborativeEducation.vue?vue&type=script&lang=js"
export * from "./CollaborativeEducation.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeEducation.vue?vue&type=style&index=0&id=95ee8fb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee8fb4",
  null
  
)

export default component.exports